// popuputils.js
import axios from 'axios';
import { parselemmaUrlParams } from './LemmaPageUtils'

export const fetchHeadwordSuggestions = async (baseHostUrl,selectedType, searchName, sortBy = 'best-match',searchpath='lemmasuggestion') => {
  try {
    const name = searchName.trim() !== '' ? searchName : 'all';
    // const { para_wordtags } = parselemmaUrlParams();
    const curpage = 1
    const latitude = 0;
    const longitude = 0;
    const { para_type, para_name, para_rating, para_reviews, para_sort_by,para_page, para_wordtags } = parselemmaUrlParams();
    //force to use all for wordtag and selectedType
    const para_wordtags_2 = 'all'
    selectedType ='all'
    const suggestionquery = `${baseHostUrl}/${searchpath}?type=${encodeURIComponent(selectedType)}` + 
      `&wordtag=${encodeURIComponent(para_wordtags_2)}` +
      `&name=${encodeURIComponent(name)}` +
      `&rating=${para_rating}&user_ratings_total=${para_reviews}` +
      `&sortby=${encodeURIComponent(sortBy)}` +
      `&lat=${encodeURIComponent(latitude)}&lon=${encodeURIComponent(longitude)}` +
      `&page=${encodeURIComponent(curpage)}`;

    // let query = `${baseHostUrl}/lemmasearch/type=${encodeURIComponent(selectedType)}?page=1`;

    // if (name !== 'all') {
    //   query += `&name=${encodeURIComponent(name)}`;
    // }

    // if (sortBy !== 'best-match') {
    //   query += `&sort=${encodeURIComponent(sortBy)}`;
    // }
    // query += `&wordtag=${encodeURIComponent(para_wordtags)}`;

    const response = await axios.get(suggestionquery, { withCredentials: true });
    return response.data || [];
  } catch (error) {
    console.error('Error fetching suggestions:', error);
    return [];
  }
};
